module.exports = __webpack_public_path__ + "mine.e529250a351189e4d41f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/minesweeper/components/assets/mine.png
// module id = 31
// module chunks = 1